import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { language, lang } = this.props

    let rewardList = [
      {
        type: 'A',
        roomPopularity: '90',
        weeklyRTr: '>=30k',
        weeklySup: 'Room Owner<br />= 2k;<br />Admin<br/>= 3*1k',
        total: '5k',
      },
      {
        type: 'B',
        roomPopularity: '100',
        weeklyRTr: '>=50k',
        weeklySup: 'Room Owner<br />= 3k;<br />Admin<br/>= 4*1.5k',
        total: '9k',
      },
      {
        type: 'C',
        roomPopularity: '250',
        weeklyRTr: '>=100k',
        weeklySup: 'Room Owner<br />= 6k;<br />Admin<br/>= 4*3k',
        total: '18k',
      },
      {
        type: 'D',
        roomPopularity: '500',
        weeklyRTr: '>=300k',
        weeklySup: 'Room Owner<br />= 12k;<br />Admin<br/>= 5*7k',
        total: '47k',
      },
      {
        type: 'E',
        roomPopularity: '800',
        weeklyRTr: '>=500k',
        weeklySup: 'Room Owner<br />= 17k;<br />Admin<br/>= 5*15k',
        total: '92k',
      },
      {
        type: 'F',
        roomPopularity: '1000',
        weeklyRTr: '>=800k',
        weeklySup: 'Room Owner<br />= 23k;<br />Admin<br/>= 6*18k',
        total: '131k',
      },
      {
        type: 'G',
        roomPopularity: '1500',
        weeklyRTr: '>=1M',
        weeklySup: 'Room Owner<br />= 35k;<br />Admin<br/>= 6*20k',
        total: '155k',
      },
      {
        type: 'H',
        roomPopularity: '2500',
        weeklyRTr: '>=2M',
        weeklySup: 'Room Owner<br />= 70k;<br />Admin<br/>= 8*25k',
        total: '270k',
      },
      {
        type: 'I',
        roomPopularity: '5000',
        weeklyRTr: '>=3M',
        weeklySup: 'Room Owner<br />= 120k;<br />Admin<br/>= 12*30k',
        total: '480k',
      },
      {
        type: 'J',
        roomPopularity: '7000',
        weeklyRTr: '>=5M',
        weeklySup: 'Room Owner<br />= 220k;<br />Admin<br/>= 12*37k',
        total: '664k',
      },
      {
        type: 'K',
        roomPopularity: '10000',
        weeklyRTr: '>=8M',
        weeklySup: 'Room Owner<br />= 320k;<br />Admin<br/>= 15*45k',
        total: '995k',
      },
      {
        type: 'L',
        roomPopularity: '15000',
        weeklyRTr: '>=10M',
        weeklySup: 'Room Owner<br />= 440k;<br />Admin<br/>= 15*55k',
        total: '1.265M',
      },
      {
        type: 'M',
        roomPopularity: '18000',
        weeklyRTr: '>=15M',
        weeklySup: 'Room Owner<br />= 540k;<br />Admin<br/>= 20*65k',
        total: '1.84M',
      },
      {
        type: 'N',
        roomPopularity: '20000',
        weeklyRTr: '>=20M',
        weeklySup: 'Room Owner<br />= 840k;<br />Admin<br/>= 22*85k',
        total: '2.71M',
      },
      {
        type: 'O',
        roomPopularity: '30000',
        weeklyRTr: '>=30M',
        weeklySup: 'Room Owner<br />= 1.2M;<br />Admin<br/>= 23*150k',
        total: '4.65M',
      },
    ]

    let superBonusList = [
      {
        left: '80,000',
        right: '8,000 golds'
      },
      {
        left: '150,000',
        right: '10,000 golds'
      },

      {
        left: '300,000',
        right: '20,000 golds'
      },
      {
        left: '500,000',
        right: '30,000 golds'
      },
      {
        left: '900,000',
        right: '60,000 golds'
      },
      {
        left: '1500,000',
        right: '80,000 golds'
      },
      {
        left: '2000,000',
        right: '120,000 golds'
      },
      {
        left: '3000,000',
        right: '200,000 golds'
      },
      {
        left: '6000,000',
        right: '500,000 golds'
      },
      {
        left: '10,000,000',
        right: '700,000 golds'
      },
      {
        left: '15,000,000',
        right: '1,000,000 golds'
      },
      {
        left: '30,000,000',
        right: '2,000,000 golds'
      },
    ]


    return (
      <div className="reward">
        {/* {language == 'ar' && <img src="/img/app/roomsupport/honor-ar3.jpg" />}
        {language == 'tr' && <img src="/img/app/roomsupport/honor-tr3.jpg" />}
        {(language == 'en' || language == 'zh') && <img src="/img/app/roomsupport/honor3.jpg" />} */}
        {/* <img src="/img/app/roomsupport/room_reward1.png" /> */}
        {/* <img src="/img/app/roomsupport/room_reward22.png" /> */}
        
        <div className='reward1'>
          <h2>{lang.RoomRewards}</h2>
          <table>
            <thead>
              <tr>
                <td className='td1'>{lang.Level}</td>
                <td className='td2'>{lang.roomPopularity}</td>
                <td className='td2'>{lang.WeeklyRoomTrophy}</td>
                <td className='td3'>{lang.WeeklySupport}</td>
                <td className='td2'>{lang.TotalSupport}</td>
              </tr>
            </thead>
            <tbody>
              {
                rewardList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.type}</td>
                      <td>{item.roomPopularity}</td>
                      <td>{item.weeklyRTr}</td>
                      <td dangerouslySetInnerHTML={{ __html: item.weeklySup }}></td>
                      <td>{item.total}</td>
                    </tr>
                  )
                })
              }


            </tbody>
          </table>
        </div>

        {/* <div className='reward1'>
          <h2>{lang.Bonus}</h2>
          <table>
            <thead>
            </thead>
            <tbody>
              {
                superBonusList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className='td4'>{item.left}</td>
                      <td className='td4'>{item.right}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div> */}

        <div className='reward1'>
          <h2>{lang.Famous}</h2>
          <table>
            <thead>
              <tr>
                <td>{lang.rwt}</td>
                <td>{lang.rm}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='td4'>1M</td>
                <td className='td4'><img src="/img/app/roomsupport/r1.png" alt="" /></td>
              </tr>
              <tr>
                <td className='td4'>5M</td>
                <td className='td4'><img src="/img/app/roomsupport/r2.png" alt="" /></td>
              </tr>
              <tr>
                <td className='td4'>10M</td>
                <td className='td4'><img src="/img/app/roomsupport/r3.png" alt="" /></td>
              </tr>
              <tr>
                <td className='td4'>20M</td>
                <td className='td4'><img src="/img/app/roomsupport/r4.png" alt="" /></td>
              </tr>
              <tr>
                <td className='td4'>50M</td>
                <td className='td4'><img src="/img/app/roomsupport/r5.png" alt="" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport/Reward/index.js